<template>
    <div class="app-main non-out">
        <div class="top-bar">
            <el-input ref="input_scan" v-model="barcode" placeholder="扫入商品条形码" @change="scanCode" style="width:240px">
                <img slot="prefix" src="./../../../assets/scan.png" alt="scan" class="input-icon">
            </el-input>
            <!-- <a href="https://myadmin.moobyyoho.com/order/getexceloutgoods">
                <el-button type="success" plain style="margin-left:20px;">打印出货单</el-button>
            </a> -->
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table :data="tableData"   height="600">
                <el-table-column prop="barcode" label="商品条形码"  align="center"></el-table-column>
                <el-table-column label="商品图片" align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.goods_sku_pic_url" :src="scope.row.goods_sku_pic_url" />
                    </template>
                </el-table-column>
                <el-table-column  prop="goods_name" label="商品名称"  align="center"  show-overflow-tooltip></el-table-column>
                <el-table-column  prop="shops_title" label="所属商家" align="center"  ></el-table-column>
                <el-table-column  prop="spec_attribute" label="规格属性" align="center" > </el-table-column>
                <el-table-column  prop="out_number"  label="应出库数量" align="center"   > </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>



<script>

import { out_scan, out_list } from "@/api/warehouse.js"
import MImg   from './../../../components/Image'
export default {
    components: { MImg },
    data() {
        return {
            barcode:'',
            tableData:[],
        }
    },
    methods: {
        // 扫码出货 自动提交
        scanCode(){
            if(this.barcode == ""){
               return false
            }
            out_scan(this.barcode).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success',offset:200 })
                    this.getData()
                }
            }).finally( () => {
                this.barcode = "";
                this.$refs.input_scan.focus()
            })
        },
        getData(){
            out_list().then(res => {
                if(res){
                    this.tableData = res.data
                }else{
                    this.tableData = []
                }
            })
        },
    },
    mounted(){
        this.getData()
        this.$refs.input_scan.focus()
    },
    activated() {
        this.getData()
        this.$refs.input_scan.focus()
    },

}
</script>
<style scoped>
.input-icon {
    width: 14px;
    height: 14px;
    margin: 13px 0 0 5px;
}
</style>

